export const configuration = {
	header: {
		heading: 'Dr. Anushruti Aggarwal',
		headingtext:
			'Dr. Anushruti Aggarwal is a distinguished dermatologist with a solid educational background. She completed her MBBS from the prestigious All India Institute of Medical Sciences (AIIMS), New Delhi, followed by her MD in Dermatology from Government Medical College (GMC), Patiala. With her wealth of knowledge and expertise, Dr. Aggarwal is committed to providing personalized care and effective solutions to her patients. ',
		buttontext: 'do some action',
		buttonlink: 'home',
	},
};
